import { Component } from "@angular/core";
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'unit-one-lesson-five-guide',
    templateUrl: './_guide.component.html',
    styleUrls: ['./_guide.component.css']
})
export class UnitOneLessonFiveGuideComponent {

    pageTitle: string = "Lesson Guide | Unit 1, Lesson 5 | T-Folio";
    title: string = "Lesson Guide";
    subtitle: string = "Lesson 5: Self-Determination";

    doPrint(): void {
        window.print();
    }
    public constructor(private titleService: Title) {
        this.titleService.setTitle(this.pageTitle);
    }
}
